export default function ModuleMockConfiguration($translatePartialLoaderProvider) {
    // On configure la gestion de la traduction en lui indiquant quel fichier json il doit charger pour ce module
    $translatePartialLoaderProvider.addPart('arrets');
}

ModuleMockConfiguration.$inject = ['$translatePartialLoaderProvider'];
